// @ts-nocheck
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { FC } from "react";
import { css } from "styled-components";

/* Starter Custom Code - Start */
import useMergeProps from "@toolkit/Framework/Common/Hooks/useMergeProps";
/* Starter Custom Code - End */

export interface CardContainerMultiColumnStyles {
    cardDivider?: InjectableCss;
    gridItem?: GridItemProps;
}

export const cardContainerMultiColumnStyles: CardContainerMultiColumnStyles = {
    gridItem: {
        width: [12, 6, 6, 4, 4],
        css: css`
            align-items: stretch;
        `,
    },
    cardDivider: {
        css: css`
            width: 100%;
            height: 100%;
        `,
    },
};

const CardContainerMultiColumn: FC<{
    extendedStyles?: CardContainerMultiColumnStyles;
}> = ({ extendedStyles, children, ...otherProps }) => {
    const styles = useMergeProps(cardContainerMultiColumnStyles, extendedStyles); // Starter Custom Code

    return (
        <GridItem {...styles.gridItem} {...otherProps}>
            <StyledWrapper {...styles.cardDivider}>{children}</StyledWrapper>
        </GridItem>
    );
};

export default CardContainerMultiColumn;
